
import apiService from '../services/api.service';

const fullLotListHash = {};

export const getProductDimensions = async() => {
  try {
    let productDimensions = null;
    const resp = await apiService.get("/inventory/getAllItems/");
    const body = resp.data;
    if (body.Result && body.Result.length) {
      productDimensions = {};
      body.Result.forEach((element) => {
        productDimensions[element.description] = element;;
      });
    }
    return productDimensions;
  } catch (e) {
    console.log("getProductDimensions inventory error", e);
    return null;
  }
}

export const filterInventoryList = async(text) => {
  try {
    console.log("remote call filterInventoryList");
    const resp = await apiService.get("/inventory/getAllItems/"); // TODO filter on server
    const body = resp.data;
    if (body.Result && body.Result.length) {

      let filteredProducts = body.Result;
      if (text) {
        filteredProducts = await body.Result.filter(product => product.description.toLowerCase().includes(text.toLowerCase()));
      }
      console.log(filteredProducts);
      filteredProducts.forEach((element) => {
        if (!element.dimensions) {
          element.dimensions = {
            length: '1',
            width: '1',
            height: '1',
            weight: '1'
          }
        }
      });
      return filteredProducts;
    }
  } catch (e) {
    console.error("filterInventoryList  error", e);
  }
  return [];
}

export const getLotNumbers = async (internalId, quantity) => {

  if (!internalId) return [];
  try {
    if (Array.isArray(fullLotListHash[internalId])) {
      console.log("--found cached lots " + internalId + " " + quantity);
      return fullLotListHash[internalId];
    } else {
      console.log("------------------------------------------------------lot search " + internalId + " " + quantity);
      let lotRows = [];
      fullLotListHash[internalId] = [];
      
      //first get all possible lot numbers
      await apiService.get('/netsuite/getLotNumbers/' + internalId)
      .then(function (response) {
        lotRows = response.data.Result;
      });

      // then get all lot numbers with available stock...
      var lots = {};
      try {
        await apiService.get(`/netsuite/getLotNumbers/${internalId}?numItemsRequested=${quantity}`)
        .then(function (response) {
          for (let i = 0; i < response.data.Result.length; i++) {
            lots[response.data.Result[i]] = true;
          }
        });
      } catch (e) {
        console.log('getLotNumbers', e);
      }

      // ...and combine info into one array
      for (let i = 0; i < lotRows.length; i++) {
        lotRows[i] = { name: lotRows[i], available: lots[lotRows[i]] ? "available" : "not available" };
      }

      fullLotListHash[internalId] = lotRows;
      return fullLotListHash[internalId];
    }
  } catch(err) {
    console.log(err);
  }
}








// WEBPACK FOOTER //
// ./src/utils/autocompleteProducts.js